import {
  FETCH_PAYMENTS_SUCCESS,
  SHOW_PAYMENTS_LOADER,
  SHOW_PAYMENTS_MESSAGE,
  HIDE_PAYMENTS_MESSAGE,
} from 'constants/ActionTypes';

const INIT_STATE = {
  loader: true,
  alertMessage: '',
  showMessage: false,
  isErrorMessage: false,
  paymentsData: [],
  pages: -1,
  page: 0,
  pageSize: 20,
  totalPaidEuro: 0, 
  totalPriceEuro: 0, 
  totalDepositEuro: 0, 
  totalPaidRsd: 0,
  totalPriceRsd: 0,
  totalDepositRsd: 0,
  pastEvaluatedKey: undefined,
  lastEvaluatedKey: undefined
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_PAYMENTS_SUCCESS: {
      return {
        ...state,
        paymentsData: action.payload.rows,
        loader: false,
        pages: Math.ceil(action.payload.count / state.pageSize),
        page: action.payload.page,
        totalPaidEuro: action.payload.total.euro.paid,
        totalPriceEuro: action.payload.total.euro.price,
        totalDepositEuro: action.payload.total.euro.deposit,
        totalPaidRsd: action.payload.total.rsd.paid,
        totalPriceRsd: action.payload.total.rsd.price,
        totalDepositRsd: action.payload.total.rsd.deposit,
        pastEvaluatedKey: (state.lastEvaluatedKey && action.payload.page !== 0) ? state.pastEvaluatedKey : action.payload.LastEvaluatedKey,
        lastEvaluatedKey: action.payload.LastEvaluatedKey
      }
    }
    case SHOW_PAYMENTS_LOADER: {
      return {
        ...state,
        page: action.payload ? Number(action.payload.page) : 0,
        loader: true
      }
    }
    case SHOW_PAYMENTS_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload.message,
        isErrorMessage: action.payload.messageStatus,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_PAYMENTS_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        isErrorMessage: false,
        showMessage: false,
        loader: false
      }
    }
    
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/Payments.js